module.exports = __webpack_public_path__ + "static/media/Card.9c08f259.svg";